import { render, staticRenderFns } from "./zhuanke.vue?vue&type=template&id=1c663622&scoped=true"
import script from "./zhuanke.vue?vue&type=script&lang=js"
export * from "./zhuanke.vue?vue&type=script&lang=js"
import style0 from "./zhuanke.vue?vue&type=style&index=0&id=1c663622&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c663622",
  null
  
)

export default component.exports